// Mock data for Miss Baleng - Institut de Beauté Afro

export const siteInfo = {
  name: "Miss Baleng",
  tagline: "Faites-vous belle, vous le méritez.",
  description: "Votre institut de beauté spécialisé dans la coiffure afro et européenne à Asnières-sur-Seine. Fondé par Yrène, plus de 10 ans d'expertise, élégance et bien-être.",
  address: "1 rue Albert de Mun, 92600 Asnières-sur-Seine",
  phone: "06 19 21 17 90",
  email: "baleng.miss@yahoo.com",
  hours: {
    weekdays: "10h30 - 19h30",
    saturday: "09h30 - 19h30",
    sunday: "10h30 - 19h30"
  },
  social: {
    instagram: "https://instagram.com/missbaleng_",
    facebook: "https://facebook.com/missbaleng",
    tiktok: "https://tiktok.com/@missbaleng_"
  }
};

export const services = [
  {
    id: 1,
    category: "Coiffure Afro & Européenne",
    icon: "Scissors",
    description: "Expertise en coiffure afro et européenne : tresses, locks, tissages, brushing et coupes",
    image: "https://images.unsplash.com/photo-1688592969417-953dd3c2b9d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxBZnJpY2FuJTIwYnJhaWRzfGVufDB8fHx8MTc2NDYxNTIwNXww&ixlib=rb-4.1.0&q=85",
    items: [
      { name: "Tresses africaines", price: "À partir de 80€", duration: "2h - 4h" },
      { name: "Box braids", price: "À partir de 120€", duration: "4h - 6h" },
      { name: "Cornrows", price: "À partir de 60€", duration: "1h30 - 3h" },
      { name: "Locks (création)", price: "À partir de 150€", duration: "3h - 5h" },
      { name: "Entretien locks", price: "À partir de 50€", duration: "1h - 2h" },
      { name: "Tissage", price: "À partir de 70€", duration: "1h30 - 2h" },
      { name: "Perruque pose", price: "À partir de 40€", duration: "45min - 1h" },
      { name: "Coupe afro", price: "À partir de 25€", duration: "30min - 1h" },
      { name: "Brushing", price: "À partir de 35€", duration: "45min - 1h" },
      { name: "Coloration", price: "À partir de 55€", duration: "1h - 2h" }
    ]
  },
  {
    id: 2,
    category: "Manucure",
    icon: "Sparkles",
    description: "Des mains sublimes avec nos soins manucure professionnels",
    image: "https://images.unsplash.com/photo-1604654894610-df63bc536371?w=800",
    items: [
      { name: "Manucure classique", price: "25€", duration: "30min" },
      { name: "Manucure semi-permanent", price: "40€", duration: "45min" },
      { name: "Pose gel", price: "55€", duration: "1h" },
      { name: "Nail art", price: "À partir de 10€", duration: "15min+" },
      { name: "Dépose", price: "15€", duration: "20min" },
      { name: "Soin des mains", price: "30€", duration: "30min" }
    ]
  },
  {
    id: 3,
    category: "Pédicure",
    icon: "Footprints",
    description: "Prenez soin de vos pieds avec nos soins pédicure experts",
    image: "https://images.unsplash.com/photo-1519014816548-bf5fe059798b?w=800",
    items: [
      { name: "Pédicure classique", price: "35€", duration: "45min" },
      { name: "Pédicure semi-permanent", price: "50€", duration: "1h" },
      { name: "Pédicure spa", price: "60€", duration: "1h15" },
      { name: "Soin des pieds", price: "40€", duration: "45min" },
      { name: "Pose vernis pieds", price: "20€", duration: "20min" }
    ]
  },
  {
    id: 4,
    category: "Soins Visage",
    icon: "Heart",
    description: "Des soins adaptés aux peaux noires et métissées pour un teint éclatant",
    image: "https://images.unsplash.com/photo-1639162906614-0603b0ae95fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxiZWF1dHklMjBzcGElMjB0cmVhdG1lbnR8ZW58MHx8fHwxNzY0NjE1MjExfDA&ixlib=rb-4.1.0&q=85",
    items: [
      { name: "Soin visage classique", price: "55€", duration: "1h" },
      { name: "Soin hydratant intense", price: "70€", duration: "1h15" },
      { name: "Soin anti-taches", price: "85€", duration: "1h15" },
      { name: "Soin éclat du teint", price: "75€", duration: "1h" },
      { name: "Nettoyage de peau", price: "45€", duration: "45min" },
      { name: "Gommage visage", price: "35€", duration: "30min" }
    ]
  }
];

export const products = [
  {
    id: 1,
    name: "Huile de Ricin Pure",
    brand: "Miss Baleng Care",
    price: "18€",
    category: "Soins capillaires",
    description: "Huile de ricin 100% pure pour fortifier et faire pousser vos cheveux.",
    image: "https://images.unsplash.com/photo-1608248597279-f99d160bfcbc?w=400"
  },
  {
    id: 2,
    name: "Beurre de Karité Brut",
    brand: "African Gold",
    price: "22€",
    category: "Soins capillaires",
    description: "Beurre de karité non raffiné du Ghana pour hydrater cheveux et peau.",
    image: "https://images.unsplash.com/photo-1601049541289-9b1b7bbbfe19?w=400"
  },
  {
    id: 3,
    name: "Crème Hydratante Visage",
    brand: "Nubian Queen",
    price: "35€",
    category: "Soins visage",
    description: "Crème hydratante spéciale peaux noires et métissées au beurre de cacao.",
    image: "https://images.unsplash.com/photo-1570194065650-d99fb4b38b15?w=400"
  },
  {
    id: 4,
    name: "Sérum Anti-Taches",
    brand: "Melanin Glow",
    price: "45€",
    category: "Soins visage",
    description: "Sérum unifiant pour atténuer les taches et sublimer votre teint.",
    image: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=400"
  },
  {
    id: 5,
    name: "Huile de Coco Vierge",
    brand: "Miss Baleng Care",
    price: "15€",
    category: "Soins capillaires",
    description: "Huile de coco vierge pressée à froid pour nourrir vos cheveux en profondeur.",
    image: "https://images.unsplash.com/photo-1590301157890-4810ed352733?w=400"
  },
  {
    id: 6,
    name: "Leave-In Conditioner",
    brand: "Curly Crown",
    price: "28€",
    category: "Soins capillaires",
    description: "Soin sans rinçage pour démêler et définir vos boucles naturelles.",
    image: "https://images.unsplash.com/photo-1556227702-d1e4e7b5c232?w=400"
  },
  {
    id: 7,
    name: "Gel Edge Control",
    brand: "Sleek & Shine",
    price: "12€",
    category: "Coiffure",
    description: "Gel edge control longue tenue pour des baby hair parfaits.",
    image: "https://images.unsplash.com/photo-1597931752949-98c74b5b159f?w=400"
  },
  {
    id: 8,
    name: "Vernis Semi-Permanent",
    brand: "NailArt Pro",
    price: "16€",
    category: "Ongles",
    description: "Vernis semi-permanent longue tenue, collection couleurs nude et doré.",
    image: "https://images.unsplash.com/photo-1604654894610-df63bc536371?w=400"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Aminata D.",
    rating: 5,
    text: "Miss Baleng est mon institut préféré ! Les coiffeuses sont expertes en tresses et prennent vraiment soin de mes cheveux. Je recommande à 100%.",
    service: "Tresses africaines",
    image: "https://images.unsplash.com/photo-1602580404246-225af00637ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHwyfHxBZnJpY2FuJTIwd29tYW4lMjBiZWF1dHl8ZW58MHx8fHwxNzY0NjE1MTk5fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    name: "Fatou M.",
    rating: 5,
    text: "Un vrai moment de détente ! Les soins visage sont parfaitement adaptés à ma peau. Mon teint n'a jamais été aussi lumineux.",
    service: "Soin éclat du teint",
    image: "https://images.unsplash.com/photo-1639531167411-2fbab09f57f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHw0fHxBZnJpY2FuJTIwd29tYW4lMjBiZWF1dHl8ZW58MHx8fHwxNzY0NjE1MTk5fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    name: "Precious O.",
    rating: 5,
    text: "Mes locks sont magnifiques grâce à Miss Baleng ! L'équipe est professionnelle, accueillante et vraiment passionnée par son métier.",
    service: "Entretien locks",
    image: "https://images.unsplash.com/photo-1667498235477-0dcfc8593de8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxBZnJpY2FuJTIwYnJhaWRzfGVufDB8fHx8MTc2NDYxNTIwNXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    name: "Sarah K.",
    rating: 5,
    text: "La meilleure manucure de ma vie ! Les nail artists sont créatives et le résultat est toujours impeccable. J'adore !",
    service: "Manucure semi-permanent",
    image: "https://images.unsplash.com/photo-1741940365113-4c77bdc325e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxBZnJpY2FuJTIwYnJhaWRzfGVufDB8fHx8MTc2NDYxNTIwNXww&ixlib=rb-4.1.0&q=85"
  }
];

export const gallery = [
  {
    id: 1,
    before: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=400",
    after: "https://images.unsplash.com/photo-1688592969417-953dd3c2b9d8?w=400",
    category: "Coiffure",
    title: "Transformation Box Braids"
  },
  {
    id: 2,
    before: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=400",
    after: "https://images.unsplash.com/photo-1667498235477-0dcfc8593de8?w=400",
    category: "Coiffure",
    title: "Tresses Fulani"
  },
  {
    id: 3,
    before: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=400",
    after: "https://images.unsplash.com/photo-1741940365113-4c77bdc325e0?w=400",
    category: "Coiffure",
    title: "Style Locks"
  }
];

export const timeSlots = [
  "09:00", "09:30", "10:00", "10:30", "11:00", "11:30",
  "12:00", "12:30", "14:00", "14:30", "15:00", "15:30",
  "16:00", "16:30", "17:00", "17:30", "18:00"
];

export const blogPosts = [
  {
    id: 1,
    title: "10 astuces pour faire pousser vos cheveux afro",
    excerpt: "Découvrez nos conseils d'expertes pour stimuler la pousse de vos cheveux naturels.",
    date: "15 Août 2025",
    category: "Conseils capillaires",
    image: "https://images.unsplash.com/photo-1688592969417-953dd3c2b9d8?w=600"
  },
  {
    id: 2,
    title: "Les bienfaits du beurre de karité pour la peau",
    excerpt: "Le beurre de karité est un trésor pour les peaux noires. Voici comment l'utiliser.",
    date: "10 Août 2025",
    category: "Soins peau",
    image: "https://images.unsplash.com/photo-1639162906614-0603b0ae95fd?w=600"
  },
  {
    id: 3,
    title: "Tendances coiffures afro 2025",
    excerpt: "Box braids, knotless, passion twists... Découvrez les coiffures tendance cette année.",
    date: "5 Août 2025",
    category: "Tendances",
    image: "https://images.unsplash.com/photo-1667498235477-0dcfc8593de8?w=600"
  }
];
